import * as React from 'react';

import * as styles from './index.css';

import { AnalyticsButton } from '../AnalyticsButton';
import { IAnalyticsBlockProps } from './typings';
import { SurveyWidgetModal } from '../SurveyWidgetModal';

export const AnalyticsBlock: React.FC<IAnalyticsBlockProps> = ({
  onButtonClick,
  onWidgetClose,
  onWidgetSubmit,
  isOpen,
  onTrackOfferPullActions,
  onOpenClick,
}) => {
  const onButtonClickWrapper = onOpenClick(onButtonClick);

  return (
    <div className={styles['container']}>
      <AnalyticsButton onClick={onButtonClickWrapper} />
      <SurveyWidgetModal
        isOpen={isOpen}
        onClose={onWidgetClose}
        onSubmit={onWidgetSubmit}
        onSOPREvent={onTrackOfferPullActions}
      />
    </div>
  );
};

AnalyticsBlock.displayName = 'AnalyticsBlock';
